// extracted by mini-css-extract-plugin
module.exports = {"wireless":"wireless-2AkzbYOs","link":"link-Cc1yxpTW","list":"list-2X7t03Vt clearfix"};